/* eslint-disable import/no-unresolved, jsx-a11y/alt-text */
import React from 'react';

import ErrorLabel from 'pu-react/components/base/ErrorLabel';

import DownloadImg from 'images/products/project_quote/download-file.png'
import ExtractZipFileTool from './ExtractZipFileTool';

const UploadTxtBtn = () => (
  <span>
    <img src={DownloadImg} />
    &nbsp;
    <span>Upload Zip File</span>
  </span>
)

const LoadingTxtBtn = () => (
  <span>
    <span className="spinner-border spinner-border-sm"
      role="status" aria-hidden="true" />
    &nbsp;
    Loading...
  </span>
)

export default (props) => {
  let txt_button;

  if (props.loadingZipFile) {
    txt_button = <LoadingTxtBtn />;
  } else {
    txt_button = <UploadTxtBtn />;
  }

  return (
    <div className="btn-action-project file-input col">
      <div className="btn btn-outline-blue btn-thin me-1 file-input py-2">
        {txt_button}
        <input
          type="file"
          className="parts-input"
          name="filename"
          onChange={e => props.onUploadZipFile(e.target.files[0])}
          disabled={props.loadingZipFile} />
      </div>
      <ErrorLabel error={props.errors.filename} />
      <ErrorLabel error={props.errors.upload_file} />
      <div className="file-name">{props.filename}</div>
      {(props.directory !== null)
        ? <ExtractZipFileTool
          directory={props.directory}
          onCloseZipFileTool={props.onCloseZipFileTool}
          onOpenBomFile={props.onOpenBomFile}
          errors={props.errors} />
        : null
      }
    </div>
  )
}
